let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3m3m4")).then(() => parcelRequire('cpbTO'));